export const API = {
  AUTH: {
    LOGIN: '/auth/login',
    LOGOUT: '/auth/logout',
    REFRESH: '/auth/refresh',
    ME: '/auth/me',
  },
  FEDERATION: {
    RESOLVE: '/api/federations/resolve',
    GET_CLUBS: '/api/federation/clubs',
    GET_CLUB_DETAIL: '/api/clubs/:id',
  },
  FORMULAIRES: {
    LIST: '/api/communication/formulaires',
  },
  MEDIATIQUE: {
    LIST: '/api/communication/mediatique',
  },
  PAGES: {
    GET_ALL: '/api/pages',
    UPDATE_FLAGS: '/api/pages',
  },
  CONTENT_MANAGER: {
    GET_ALL_PAGES: '/api/contenu_dynamic/get_all_pages',
    GET_BY_PAGE:   '/api/contenu_dynamic/get_by_page',
    GET_BY_ID:     '/api/contenu_dynamic/get_by_id',
    SAVE_PAGE:     '/api/contenu_dynamic/save_page',
  },
  DOCUMENTS: {
    LIST: '/api/documents/list',
    GET_BY_PAGE: '/api/documents/get_by_page',
    GET_BY_ID: '/api/documents/get_by_id',
    ADD: '/api/documents/add',
    UPDATE: '/api/documents/update',
    DELETE: '/api/documents/delete',
    REORDER: '/api/documents/reorder',
    PROXY: '/api/documents/proxy',
  },
  CONTENT: {
    GET_CATEGORIES: '/api/content/get_categories',
    GET_BY_CATEGORY: '/api/content/get_by_category',
    GET_BY_ID: '/api/content/get_by_id',
    ADD: '/api/content/add',
    UPDATE: '/api/content/update',
    DELETE: '/api/content/delete',
  },
  INT_INSTANCES: {
    GET_ALL:    '/api/int_instances/get_all',
    GET_BY_ID:  '/api/int_instances/get_by_id',
    ADD:        '/api/int_instances/add',
    UPDATE:     '/api/int_instances/update',
    SET_STATUS: '/api/int_instances/status',
    DELETE:     '/api/int_instances/delete',
  },
  BUREAU_EXECUTIF: {
    LIST:            '/api/bureau-executif',
    GET_BY_ID:       '/api/bureau-executif',
    MEMBERS_SEARCH:  '/api/bureau-executif/ref/members-search',
    ADD:             '/api/bureau-executif',
    REMOVE:          '/api/bureau-executif',
  },
  MEMBERS: {
    LIST:       '/api/members',
    GET_BY_ID:  '/api/members',
    CREATE:     '/api/members',
    UPDATE:     '/api/members',
    SET_STATUS: '/api/members',
  },
  CODIFICATIONS: '/api/codifications',
  ADMINISTRATION: {
    LIST:            '/api/administration',
    GET_BY_ID:       '/api/administration',
    CREATE:          '/api/administration',
    UPDATE:          '/api/administration',
    SET_STATUS:      '/api/administration',
    MEMBERS_SEARCH:  '/api/administration/ref/members-search',
  },
  HISTORY_EVENTS: {
    GET_ALL:    '/api/history_events/get_all',
    GET_BY_ID:  '/api/history_events/get_by_id',
    ADD:        '/api/history_events/add',
    UPDATE:     '/api/history_events/update',
    SET_STATUS: '/api/history_events/status',
    DELETE:     '/api/history_events/delete',
  },
};
